module.exports = __webpack_public_path__ + "img/braintree-logo-black.b3277232.png";